import { useContext } from 'react';
import { PreferencesContext } from 'context/PreferencesProvider';
import useAPI from 'hooks/useAPI';
import useGetUser from 'hooks/useGetUser';
import { useAGLOCampaign } from 'hooks/useAGLOCampaign';

const useDashboardScope = () => {
  const { api } = useAPI();
  const { user, activeOrganizationId, activeOrganizationName, activeRole, isConnected, isAGLO } = useGetUser();
  const { campaignYear: operationalYear } = useContext(PreferencesContext);
  const { selectedCampaignYear, params } = useAGLOCampaign();
  const campaignYear = isAGLO ? selectedCampaignYear ?? operationalYear : operationalYear;
  const queryParams = isAGLO ? params : { year: campaignYear };
  const enabled = !!(campaignYear && user?.id && activeOrganizationId && activeRole && isConnected);
  const scope = [campaignYear, user?.id, activeOrganizationId, activeRole];

  const queryOptions = {
    enabled,
    keepPreviousData: false,
    staleTime: 0,
    refetchOnMount: true,
  };

  return { activeOrganizationName, api, campaignYear, enabled, queryOptions, scope, queryParams, isAGLO };
};

export default useDashboardScope;
